module.exports = __webpack_public_path__ + "static/media/device_privatization.8c293652.md";